import { TShirtSize } from './sizing'
import { exhaustive } from './type-assertions'

export const sizeToFaIconSize = (size: TShirtSize) => {
  switch (size) {
    case 'extra-small':
      return '1x'
    case 'small':
      return '2x'
    case 'medium':
      return '4x'
    case 'large':
      return '8x'
    case 'extra-large':
      return '10x'
    default:
      exhaustive(size)
  }
}
